import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';

const CadastroSucesso = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tipo = searchParams.get('tipo') || 'PJ';
  const [contador, setContador] = useState(5);

  useEffect(() => {
    // 🔥 Disparar evento de conversão no Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'CompleteRegistration', {
        content_name: 'Cadastro Lembrou',
        status: true,
        currency: 'BRL',
        value: 0,
      });
    }

    // 🔥 Disparar evento no GTM / dataLayer
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cadastro_concluido',
        tipo_usuario: tipo,
      });
    }
  }, []);

  // Countdown e redirect automático
  useEffect(() => {
    if (contador <= 0) {
      navigate(tipo === 'PF' ? '/timeline' : '/dashboard');
      return;
    }
    const timer = setTimeout(() => setContador(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [contador, tipo, navigate]);

  const handleContinuar = () => {
    navigate(tipo === 'PF' ? '/timeline' : '/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">

        {/* Ícone de sucesso */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center animate-bounce">
            <CheckCircle2 className="w-14 h-14 text-green-500" />
          </div>
        </div>

        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <img src="/favicon-32x32.png" alt="Lembrou?" className="w-8 h-8" />
          <span className="text-2xl font-bold text-primary">Lembrou?</span>
        </div>

        {/* Título */}
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Conta criada com sucesso! 🎉
        </h1>
        <p className="text-gray-500 mb-8 text-lg">
          Bem-vindo ao Lembrou! Seus clientes nunca mais vão esquecer um prazo.
        </p>

        {/* Cards de próximos passos */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-6 text-left space-y-4">
          <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
            Próximos passos
          </p>
          <div className="flex items-start gap-3">
            <span className="w-6 h-6 rounded-full bg-primary text-white text-xs flex items-center justify-center font-bold flex-shrink-0 mt-0.5">1</span>
            <p className="text-sm text-gray-700">
              <strong>Configure seu perfil</strong> e adicione o telefone da sua empresa para que seus clientes possam falar com você.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <span className="w-6 h-6 rounded-full bg-primary text-white text-xs flex items-center justify-center font-bold flex-shrink-0 mt-0.5">2</span>
            <p className="text-sm text-gray-700">
              <strong>Compartilhe seu QR Code</strong> com seus clientes para que eles se cadastrem automaticamente.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <span className="w-6 h-6 rounded-full bg-primary text-white text-xs flex items-center justify-center font-bold flex-shrink-0 mt-0.5">3</span>
            <p className="text-sm text-gray-700">
              <strong>Pronto!</strong> O Lembrou cuida dos avisos automaticamente por WhatsApp e Email.
            </p>
          </div>
        </div>

        {/* Botão */}
        <button
          onClick={handleContinuar}
          className="w-full flex items-center justify-center gap-2 px-6 py-4 rounded-2xl bg-primary hover:bg-primary-hover text-white font-semibold text-lg transition-all shadow-lg hover:shadow-xl"
        >
          Acessar meu painel
          <ArrowRight className="w-5 h-5" />
        </button>

        {/* Contador */}
        <p className="text-sm text-gray-400 mt-4">
          Redirecionando automaticamente em <strong className="text-primary">{contador}s</strong>...
        </p>

      </div>
    </div>
  );
};

export default CadastroSucesso;
